module.exports = __webpack_public_path__ + "img/max-file-search.80e4727e.svg";